import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useFieldArray } from "react-hook-form";

import { FurtherStepSection } from "./FurtherStepSection";
import { FormData } from "../formSchema";

interface FurtherStepsSectionProps {
    name: number; // index of the response handler in the responseHandlers array
    methodIndex: number; // index of the method in the methods array
}

export const FurtherStepsSection: React.FC<FurtherStepsSectionProps> = ({ name, methodIndex }) => {
    const { t } = usePaldockTranslation("ui.connection-creator-editor.response-further-steps");
    const generalFormUtils = useGeneralForm<FormData>();
    const { control } = generalFormUtils;

    const furtherStepsPath = `methods.${methodIndex}.requestConfig.responseHandlers.${name}.stepConnection` as const;

    const { fields, append, remove } = useFieldArray({
        control,
        name: furtherStepsPath,
    });

    return (
        <Collapseable
            title={t("sections.further_steps.title")}
            withAddItem
            handleAddItem={() => append({})}
            addItemTitle={t("sections.further_steps.add_item")}
            className="bg-neutral-200"
        >
            {fields.map((field, index) => (
                <FurtherStepSection
                    key={field.id}
                    name={index}
                    methodIndex={methodIndex}
                    responseHandlerIndex={name}
                    handleRemove={() => remove(index)}
                />
            ))}
        </Collapseable>
    );
};
